export const APP_TITLE = `TOL Management`
